import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';


@Component({
  selector: 'app-invoice-link-modal',
  templateUrl: './invoice-link-modal.component.html',
  styles: []
})
export class InvoiceLinkModalComponent implements OnInit {

  @Input() invoiceUrl;
  invResponse: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private loaderService: LoaderService) {
  }

  ngOnInit() {
    if(this.invoiceUrl){
      this.invResponse = { 'url' : this.invoiceUrl};
    }
  }

  copyLink(inputElement?: any) {
    try {
      inputElement.select();
      (document as any).execCommand('copy');
      inputElement.setSelectionRange(0, 0);

      Swal.fire(i18n.done, i18n.invoice.invoice_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }
}
